import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { MintDetail, MintDetailProps } from './MintDetail';
import { useTheme } from '@mui/material/styles';

export interface MintDetailsPanelProps {
  mintDetails: MintDetailProps[];
}

export function MintDetailsPanel({ mintDetails }: MintDetailsPanelProps) {
  const theme = useTheme();
  return (
    <Stack
      gap="12px"
      direction="column"
      alignItems="stretch"
      justifyContent="flex-start"
      textAlign="left"
      sx={{
        backgroundColor: theme.palette.background.elevation['2'],
        boxShadow: theme.shadowsHard.emboss,
        backdropFilter: 'blur(2.5px)',
        borderRadius: '4px',
        paddingX: '24px',
        paddingY: '12px',
      }}
    >
      {mintDetails.map(({ detailContent, detailTitle }, index) => (
        <Box sx={{ paddingTop: index === 0 ? 0 : '12px' }} key={detailTitle}>
          <MintDetail detailTitle={detailTitle} detailContent={detailContent} />
        </Box>
      ))}
    </Stack>
  );
}
